import { sendCrossTabMessage } from 'calling-cross-tab-library/external/sendCrossTabMessage';
import { createBroadcastMessage } from 'calling-integration-cross-tab/messages/createBroadcastMessages';
import { INITIATE_OUTBOUND_CALL } from 'calling-integration-cross-tab/types/BroadcastEvents';
import openCallingWidget from 'calling-global-api/methods/openCallingWidget';
import { logCallingError, logError } from 'calling-error-reporting/report/error';
import { CALLING_EXTENSIONS_CLICK_TO_CALL_MIGRATION } from 'calling-internal-common/constants/CallingGates';
import { OrderedMap } from 'immutable';
const getPhoneNumberPropertiesToSend = phoneNumberProperties => {
  if (!phoneNumberProperties) return [];
  if (Array.isArray(phoneNumberProperties)) {
    return phoneNumberProperties.map(property => property.toJS());
  }
  if (OrderedMap.isOrderedMap(phoneNumberProperties)) {
    return phoneNumberProperties.toJS();
  }
  return phoneNumberProperties;
};
export const triggerThirdPartyOutboundCall = ({
  objectId,
  objectTypeId,
  phoneNumberProperties,
  numberPropertyName,
  gates,
  selectedCallProvider,
  threadId
}) => {
  const isUngatedForExtensionsClickToCallMigration = gates.includes(CALLING_EXTENSIONS_CLICK_TO_CALL_MIGRATION);
  const isTopNavExperienceEnabled = !!selectedCallProvider.supportsInboundCalling;
  const toSubject = {
    objectId,
    objectTypeId,
    phoneNumberProperties,
    numberPropertyName,
    threadId
  };
  if (isUngatedForExtensionsClickToCallMigration && isTopNavExperienceEnabled) {
    const phoneNumberPropertiesToSend = getPhoneNumberPropertiesToSend(phoneNumberProperties);
    sendCrossTabMessage(createBroadcastMessage({
      type: INITIATE_OUTBOUND_CALL,
      payload: {
        toSubject: Object.assign({}, toSubject, {
          phoneNumberProperties: phoneNumberPropertiesToSend
        }),
        callProvider: selectedCallProvider.toJS()
      }
    })).catch(error => {
      logCallingError({
        error,
        tags: {
          requestName: 'sendCrossTabMessage - initiate outbound call'
        }
      });
    });
  } else {
    openCallingWidget({
      toSubject: {
        objectId,
        objectTypeId,
        phoneNumberProperties,
        numberPropertyName,
        threadId
      },
      startCall: true,
      callingProvider: selectedCallProvider
    }).catch(error => {
      logError(error);
    });
  }
};